import { useRecoilState } from 'recoil';

import { Button } from '@/components/ui/button';

import { useDisclosureSettings } from '@/hooks/useDisclosureSettings';

import { rightSidebarPanelState } from '@/state/project';

export function DisclosureFooterLink() {
    const [panel, setPanel] = useRecoilState(rightSidebarPanelState);
    const { enabled } = useDisclosureSettings();

    if (!enabled) return null;

    return (
        <Button
            variant="ghost"
            onClick={() =>
                setPanel(panel === 'disclosure' ? null : 'disclosure')
            }
            aria-pressed={panel === 'disclosure'}
            className="h-auto p-0 rounded-sm underline underline-offset-2"
        >
            Read the disclosure
        </Button>
    );
}
